export const resolveOnboardingElement = (selector: string): Element | undefined => {
  const elements = Array.from(document.querySelectorAll(selector));

  return elements.find((element) => {
    if (!(element instanceof HTMLElement)) {
      return false;
    }

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  });
};
